import { Loading } from "@carbon/react";
import React from "react";

import { useT } from "src/internationalization";

const OverlayLoading: React.FC<{ description?: string }> = ({ description }) => {
  const t = useT();
  return <Loading active={true} description={description ?? t("app.loading")} withOverlay={true} />;
};

export default OverlayLoading;
